import React, { useState } from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { FiFilter, FiChevronDown, FiX } from 'react-icons/fi';

interface Props {
  activeCount: number;
  onClear: () => void;
  children: React.ReactNode;
}

export const FilterPanel: React.FC<Props> = ({ activeCount, onClear, children }) => {
  const { darkMode } = useTheme();
  const [open, setOpen] = useState(false);

  return (
    <div>
      <button
        onClick={() => setOpen(!open)}
        className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm ${darkMode ? 'hover:bg-gray-800 text-gray-300' : 'hover:bg-gray-100 text-gray-600'}`}
      >
        <FiFilter className="w-3.5 h-3.5" />
        Filters
        {activeCount > 0 && (
          <span className="bg-violet-600 text-white text-xs rounded-full px-1.5 py-0.5 min-w-[18px] text-center">{activeCount}</span>
        )}
        <FiChevronDown className={`w-3 h-3 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className={`mt-2 p-4 rounded-lg border ${darkMode ? 'bg-gray-800/50 border-gray-700' : 'bg-gray-50 border-gray-200'}`}>
          <div className="flex justify-between items-center mb-3">
            <span className={`text-xs font-medium ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
              {activeCount} active filter{activeCount !== 1 ? 's' : ''}
            </span>
            {activeCount > 0 && (
              <button onClick={onClear} className="text-xs text-violet-400 hover:text-violet-300 flex items-center gap-1">
                <FiX className="w-3 h-3" /> Clear all
              </button>
            )}
          </div>
          <div className="flex flex-wrap gap-3">
            {children}
          </div>
        </div>
      )}
    </div>
  );
};
